"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMonthCalendar = exports.StyledMonthCalendarWrapper = exports.StyledMonthCalendarFooter = exports.StyledMonthCalendarMonth = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../helpers");
const Month_1 = require("./components/Month/Month");
exports.StyledMonthCalendarMonth = (0, styled_components_1.default)(Month_1.Month) `
    padding-left: ${helpers_1.SPACING_S};
    padding-right: ${helpers_1.SPACING_S};
`;
exports.StyledMonthCalendarFooter = styled_components_1.default.div `
    display: flex;
    margin-top: ${helpers_1.SPACING_M};
`;
exports.StyledMonthCalendarWrapper = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
`;
exports.StyledMonthCalendar = styled_components_1.default.div `
    display: inline-flex;
    flex-direction: column;
`;
//# sourceMappingURL=MonthCalendar.styles.js.map